module.exports = __webpack_public_path__ + "static/media/bd-speakers-image.03ce7dff.png";